import React, { Fragment } from 'react'
import PresenceContainer from './components/PresenceContainer'

export default ({ utils: { createStore } }) => () => {
  const store = createStore({
    selection: null,
    presenceState: {
      blockId: null,
      wroteAt: null,
      isWriting: null,
    },
  })

  function hasWritingOperations(editor) {
    const WRITING_OPERATIONS_TYPES = ['insert_text', 'remove_text']
    return Boolean(
      editor.operations.find(operation =>
        WRITING_OPERATIONS_TYPES.includes(operation.type)
      )
    )
  }

  return [
    {
      onConstruct(editor, next) {
        store.reset()
        return next()
      },

      onChange(editor, next) {
        if (!editor.value.focusBlock) {
          return next()
        }

        if (editor.value.selection !== store.getItem('selection')) {
          const blockId = editor.value.focusBlock.getIn(['data', 'id'])
          const isWriting = hasWritingOperations(editor)

          store.updateItem('selection', editor.value.selection)
          store.updateItem('presenceState', {
            blockId,
            isWriting,
            wroteAt: isWriting
              ? new Date().toISOString()
              : store.getItem('presenceState').wroteAt,
          })
        }
        return next()
      },

      renderEditor: (props, editor, next) => (
        <Fragment>
          {next()}
          <PresenceContainer editor={editor} pluginStore={store} />
        </Fragment>
      ),
    },
  ]
}
